export const SOUND_ALARM_SIGNAL_INTERVAL_MS = 10000;
export const SOUND_ALARM_REFRESH_EVENT = "sound-alarm:refresh";
